import Select from "@/common/elements/InputElements/Select";
import { IntakeSectionHeader } from "@/common/styles";
import { Col, Row } from "antd";
import { FormContainer } from "../InmateDetails/styles";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import { getOptionsFromRefList } from "@/util/common_function";

const S3Information = ({ formData, updateFormData, disabled }) => {
  return (
    <>
      <section>
        <IntakeSectionHeader>
          <span>S3 Information</span>
        </IntakeSectionHeader>
        <FormContainer>
          <Row gutter={16}>
            <Col span={6}>
              <FormItem
                name={["detentionsArrestReports", 0, "inmateTypeId"]}
                label="Inmate Type"
                layout="vertical"
              >
                <Select
                  options={getOptionsFromRefList(
                    "Inmate_Type",
                    false,
                    false,
                    true
                  )}
                  placeholder="Inmate Type"
                  showSearch={false}
                  variant="outlined"
                  disabled={disabled}
                />
              </FormItem>
            </Col>
          </Row>
        </FormContainer>
      </section>
    </>
  );
};

export default S3Information;
